import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    servers: []
  },
  getters: {
    getItems(state) {
      return state.servers;
    },
    getServersOptions(state) {
      return state.servers.map(server => ({
        id: server.id,
        value: server.name,
        server_type: server.server_type
      }));
    }
  },
  mutations: {
    setItems(state, value) {
      state.servers = value;
    }
  },
  actions: {

    async getAll({ commit }, params) {
      try {
        const response = await axios.get("v1/ai-analytics/servers", {
          params
        });
        if (response.data && response.data.data) {
          commit('setItems', response.data.data);
        }
        return response.data;
      } catch (error) {
        console.error("Error fetching AI analytics servers: ", error);
        return [];
      }
    },

    async getPage(_, params) {
      const { data } = await axios.get("v1/ai-analytics/servers", {
        params
      });

      return data;
    },

    async add(_, params) {
      try {
        const { data } = await axios.post("v1/ai-analytics/servers", params);
        return data;
      } catch (error) {
        console.error("Error adding AI analytics server: ", error);
        return null;
      }
    },

    async getById(_, id) {
      const { data } = await axios.get(`v1/ai-analytics/servers/${id}`);

      return data;
    },

    async edit(_, { id, ...params }) {
      try {
        const { data } = await axios.put(`v1/ai-analytics/servers/${id}`, params);
        return data;
      } catch (error) {
        console.error(`Error editing AI analytics server with id ${id}: `, error);
        return null;
      }
    },

    async delete(_, params) {
      try {
        const { data } = await axios.delete("v1/ai-analytics/servers/devices", {
          data: params
        });
        return data;
      } catch (error) {
        console.error("Error deleting AI analytics server device: ", error);
        return null;
      }
    }
  }
};
